'use client';

import React from 'react';
import MuiTextField, {TextFieldProps} from '@new-components/atoms/MuiTextField';
import MenuItem from '@mui/material/MenuItem';
import SvgIcon from '@mui/material/SvgIcon';

type FormSelectInputProps = Pick<
  TextFieldProps,
  | 'id'
  | 'label'
  | 'helperText'
  | 'error'
  | 'name'
  | 'value'
  | 'defaultValue'
  | 'disabled'
> & {
  options: {label: string; value: string}[];
  onChange?: (value: string) => void;
  hide?: boolean;
};

export function FormSelectInput({
  options,
  onChange,
  hide,
  helperText,
  ...props
}: FormSelectInputProps) {
  if (hide) return <></>;
  return (
    <MuiTextField
      {...props}
      helperText={!helperText ? ' ' : helperText}
      select
      variant='outlined'
      fullWidth
      onChange={(e) => {
        if (onChange) onChange(e.target.value);
      }}
      sx={{
        ['& .MuiOutlinedInput-root']: {
          fieldset: {
            borderColor: '#BABAC8',
            borderRadius: '12px',
            boxShadow: '0px 1px 2px 0px #1018280D',
            top: 0,
            legend: {
              display: 'none',
            },
          },
        },
      }}
      InputLabelProps={{
        shrink: true,
        sx: {
          fontSize: '15px',
          fontWeight: 500,
          lineHeight: '18.75px',
          letterSpacing: '-0.4000000059604645px',
          textAlign: 'left',
          textUnderlinePosition: 'fromF-font',
          textDecorationSkipInk: 'none',
          color: '#82807E',
          transform: 'none',
          position: 'static',
          marginBottom: '6px',
          '&.Mui-error': {
            color: 'initial',
          },
        },
      }}
      SelectProps={{
        IconComponent: (props) => (
          <SvgIcon {...props}>
            <svg
              width='20'
              height='20'
              viewBox='0 0 20 20'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M5 7.5L10 12.5L15 7.5'
                stroke='#98A2B3'
                strokeWidth='1.66667'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </SvgIcon>
        ),
      }}
      inputProps={{
        sx: {
          borderRadius: '12px',
          padding: '8px 12px',
        },
      }}>
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </MuiTextField>
  );
}
